const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE,
  authDomain: "crwn-db-fd406.firebaseapp.com",
  databaseURL: "https://crwn-db-fd406.firebaseio.com",
  projectId: "crwn-db-fd406",
  storageBucket: "crwn-db-fd406.appspot.com",
  messagingSenderId: "930966332134",
  appId: "1:930966332134:web:6d36c335a66467fb955127",
  measurementId: "G-1MR11Y5MSE",
};

export default firebaseConfig;
